var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.vipInfo)?_c('div',[(_vm.vipInfo.vipStatusName === 'freeVip')?_c('div',{staticClass:"bubble"},[_vm._v(" 已享体验会员权益 ")]):(_vm.vipInfo.canReceiveFreeVip)?_c('div',{directives:[{name:"visually",rawName:"v-visually",value:({
            serverId: 17096,
            area: 'btn-addforfree',
        }),expression:"{\n            serverId: 17096,\n            area: 'btn-addforfree',\n        }"}],staticClass:"bubble can-click",on:{"click":function($event){return _vm.clickBubble()}}},[_vm._v(" "+_vm._s(_vm.unClaimedText)+" ")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }